module.exports = __webpack_public_path__ + "static/media/icon-binance-wallet.83810dc5.svg";